import { Action, Cross, NotAllowed, TicCircle, Uploadnew, XCircle } from "assests";
import { Button } from "components/UI/Button";
import CustomSelect from "components/UI/CustomSelect";
import CustomSelectEdition from "components/UI/CustomSelectEdition";
import Divider from "components/UI/Divider";
import Tooltip from "components/UI/Tooltip";
import UpgradeComponent from "components/UI/UpgradeComponent";
import { useSelector } from "react-redux";
import Datepicker from "react-tailwindcss-datepicker";
import { setTimeInDateObject } from "utils/helper";

const UpdateOrderPreview = ({
  data,
  seasons,
  articles,
  templates,
  // suppliers,
  agents,
  retailers,
  control,
  onChangeHandler,
  // handleErrors,
  closeModal,
  handleCancel,
  preview,
  setPreview,
  onSubmitBulkUpload,
  hasAnyError,
  uploadedData,
  showLimitText,
  orderList,
  subSupplierList,
  subTiers,
  portList,
}) => {
  const { workspacePlan } = useSelector((state) => state.billingSlice);

  const filteredSubSupplierList = (selectedSubTier) => {
    if(!selectedSubTier) return [];
    return subSupplierList?.filter((subSupplier) => subSupplier?.sub_tiers?.some((tier) => tier.type?.toLowerCase() === selectedSubTier?.toLowerCase()));
  }

  const filterSupplierTypeList = (selectedOrder) => {
    return subTiers?.filter((subTier) => selectedOrder?.orderNumber?.subSupplierIds?.includes(subTier?.id));
  }

  const getTierName = (selected) => {
    if(!selected) return null;
    return subTiers?.find((subTier) => subTier.value?.toLowerCase() === selected?.toLowerCase())?.tier?.name?.replace("_", " ");
  }

  return (
    <>
      <div className="grid grid-cols-1 h-full z-[2]">
        <div className="absolute right-5 top-5 cursor-pointer  z-[2]">
          <Cross fillColor={"#A4A7AE"} height={24} width={24} onClick={closeModal} />
        </div>
        <div className="flex justify-start ml-6 z-[1]">
          <UpgradeComponent>
            <Uploadnew />
          </UpgradeComponent>
          <div className="flex justify-between lg:gap-4 px-3 pb-9 lg:px-4 z-[2] ">
            <div className="flex flex-col gap-1">
              <h2 className="font-semibold text-sm lg:text-lg leading-7 text-start text-primary-900 w-full">
                {data.some((item) => Object.values(item.error).includes(true))
                  ? "Missing Fields"
                  : "Bulk Linking"}
              </h2>
              <div className="flex justify-start items-center">
                <p className="text-sm text-switch-active-gray font-normal text-wrap leading-5">
                  {data.some((item) => Object.values(item.error).includes(true))
                    ? `We found ${data?.length} orders in your file . Please correct any errors before proceeding.`
                    : ` ${data?.length} orders found. You may proceed with the next steps.`}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-auto z-[3] px-6">
          {showLimitText && (
            <div className="px-6 py-4">
              <div className="h-11 px-4 py-3 bg-white rounded-xl border border-[#e4e7ec] justify-start items-center gap-3 inline-flex overflow-hidden">
                <Action width={20} height={20} />
                <div className="grow shrink basis-0 text-[#535862] bg-transparent text-sm font-normal leading-tight">{`You cannot add a new order as you have reached the maximum limit of ${workspacePlan && workspacePlan?.package?.order_lines} orders in your ${workspacePlan && workspacePlan?.package?.name} plan. Please reduce your usage or upgrade your plan.`}</div>
              </div>
            </div>
          )}
          <div className="overflow-x-auto relative">
            <table className="table-auto border-spacing-y-3 px-6">
              <thead>
                <tr className="text-xs leading-3 font-medium text-table-text-header ">
                  <th className="px-6 pb-3 whitespace-nowrap">Order Number</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Article</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Supplier Type</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Tier</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Sub Supplier Name</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Supplier Name</th>
                  {/* <th className="px-6 pb-3">
                    <div className="flex items-center gap-1">
                      <span className="whitespace-nowrap">Supplier Name</span>
                      <Tooltip text="As a client, you are able to send invitations to a supplier" />
                    </div>
                  </th> */}
                  <th className="px-6 pb-3 whitespace-nowrap">Arrived</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Dispatched</th>
                  {/* <th className="px-6 pb-3">
                    <div className="flex items-center gap-1">
                      <span className="whitespace-nowrap">Dispatch Date</span>
                      <Tooltip text="Dispatch Date must not be earlier than arrival Date" />
                    </div>
                  </th> */}
                  <th className="px-6 pb-3 whitespace-nowrap">Departure Port</th>
                  <th className="px-6 pb-3 whitespace-nowrap">Arrival Port</th>
                  <th className="px-6 pb-3 whitespace-nowrap">ETD</th>
                  <th className="px-6 pb-3 whitespace-nowrap">ETA</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr
                    key={index}
                    className={`whitespace-nowrap border-b last:border-0 border-b-global-divider-soft  ${index % 2 === 0 ? "bg-global-white" : "bg-white"} rounded-lg text-global-paragraph text-sm font-normal cursor-pointer`}
                  >

                    <td className="px-6 py-3 ">
                      <div className="min-w-[135px]">
                        <CustomSelectEdition
                          control={control}
                          options={orderList}
                          name={`orderNumber${index}`}
                          value={item.orderNumber}
                          handleOnChange={(value) => onChangeHandler(index, "orderNumber", value)}
                          isError={item?.error?.orderNumberError}
                          style={{
                            padding: "4.5px 10px 5.5px 4px",
                            fontSize: "12px",
                            minWidth: "320px",
                          }}
                        />
                      </div>
                    </td>
                    <td className="px-6 py-3 ">
                      <div className="min-w-[135px]">
                        <CustomSelectEdition
                          control={control}
                          options={articles}
                          name={`articleId${index}`}
                          value={item.articleId}
                          // handleOnChange={(value) => onChangeHandler(index, "articleId", value)}
                          isError={item?.error?.articleIdError}
                          style={{
                            padding: "4.5px 10px 5.5px 4px",
                            fontSize: "12px",
                            minWidth: "320px",
                          }}
                          isDisabled={true}
                          // icon={<NotAllowed />}
                        />
                      </div>
                    </td>
                    <td className="px-6 py-3">
                      {/* <div className="min-w-[318px]"> */}
                      <div className="min-w-[250px]">
                        <CustomSelectEdition
                          isMulti={false}
                          control={control}
                          options={filterSupplierTypeList(item)}
                          name={`subTier${index}`}
                          value={item.subTier}
                          handleOnChange={(value) => onChangeHandler(index, "subTier", value)}
                          isError={item.error.subTierError}
                          style={{
                            padding: "4.5px 10px 5.5px 4px",
                            fontSize: "12px",
                            width: "auto",
                          }}
                          isClearable={false}
                        />
                      </div>
                    </td>
                    <td className="px-6 py-3 capitalize">{getTierName(item.subTier?.value)}</td>
                    <td className="px-6 py-3 ">
                      <div className="min-w-[135px]">
                        <CustomSelectEdition
                          control={control}
                          options={filteredSubSupplierList(item.subTier?.value)}
                          name={`subSupplier${index}`}
                          value={item.subSupplier}
                          // key={`${item.subSupplier}`}
                          handleOnChange={(value) => onChangeHandler(index, "subSupplier", value)}
                          isError={item?.error?.subSupplierError}
                          style={{
                            padding: "4.5px 10px 5.5px 4px",
                            fontSize: "12px",
                            minWidth: "320px",
                          }}
                          disabled={!!item.supplier}
                        />
                      </div>
                    </td>
                    <td className="px-6 py-3 ">
                      <div className="min-w-[135px]">
                        <CustomSelectEdition
                          control={control}
                          options={item.supplierList}
                          name={`supplier${index}`}
                          value={item.supplier}
                          // key={`${item.supplier}`}
                          handleOnChange={(value) => onChangeHandler(index, "supplier", value)}
                          isError={item?.error?.supplierError}
                          style={{
                            padding: "4.5px 10px 5.5px 4px",
                            fontSize: "12px",
                            minWidth: "320px",
                          }}
                          disabled={!!item.subSupplier}
                        />
                      </div>
                    </td>
                    <td className="px-6 py-3">
                      {item.subTier?.label?.toLowerCase() !== "forwarder" && (
                        <div className="relative min-w-[144px] w-full">
                        <Datepicker
                          name={`arrivalDate${index}`}
                          useRange={false}
                          asSingle={true}
                          value={item.arrivalDate}
                          placeholder={"Select date"}
                          displayFormat="DD/MM/YYYY"
                          containerClassName="certificate-date-picker "
                          inputClassName={`flex justify-between w-full gap-3 px-4 h-[44px] relative py-2 items-center text-global-title text-base placeholder:text-input-text-placeholder placeholder:text-base placeholder:font-normal self-stretch border focus:shadow-[none] focus:ring-offset-input-surface-background focus:border-input-stroke-active focus:ring-input-stroke-active bg-dropdown-surface-background rounded-lg z-[2] border-dropdown-stroke-default`}
                          primaryColor={"emerald"}
                          toggleClassName="absolute text-icon-fill-input custom-toggle-icon right-0 h-full z-[4]"
                          onChange={(value) => {
                            onChangeHandler(index, "arrivalDate", setTimeInDateObject(value));
                          }}
                          popperPlacement="auto"
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                            },
                          }}
                          disabled={item.subTier?.label?.toLowerCase() === "forwarder"}
                        />
                        {item.error.arrivalDateError && (<div className="text-gray-600 text-xs mt-1">Required</div>)}
                      </div>
                      )}
                    </td>
                    <td className="px-6 py-3">
                      {item.subTier?.label?.toLowerCase() !== "forwarder" && (
                        <div className="relative min-w-[144px] w-full">
                        <Datepicker
                          name={`dispatchDate${index}`}
                          useRange={false}
                          asSingle={true}
                          value={item.dispatchDate}
                          placeholder={"Select date"}
                          displayFormat="DD/MM/YYYY"
                          containerClassName="certificate-date-picker "
                          inputClassName={`flex justify-between w-full gap-3 px-4 h-[44px] relative py-2 items-center text-global-title text-base placeholder:text-input-text-placeholder placeholder:text-base placeholder:font-normal self-stretch border focus:shadow-[none] focus:ring-offset-input-surface-background focus:border-input-stroke-active focus:ring-input-stroke-active bg-dropdown-surface-background rounded-lg z-[2] border-dropdown-stroke-default`}
                          primaryColor={"emerald"}
                          toggleClassName="absolute text-icon-fill-input custom-toggle-icon right-0 h-full z-[4]"
                          onChange={(value) => {
                            onChangeHandler(index, "dispatchDate", setTimeInDateObject(value));
                          }}
                          popperPlacement="auto"
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                            },
                          }}
                          disabled={item.subTier?.label?.toLowerCase() === "forwarder"}
                        />
                      {(item.error.dispatchDateError && item.arrivalDate?.startDate && item.dispatchDate?.startDate && item.dispatchDate.startDate < item.arrivalDate.startDate) ? (<div className="text-gray-600 text-xs mt-1">Dispatch Date must not be earlier than arrival Date</div>) : item.error.dispatchDateError? (<div className="text-gray-600 text-xs mt-1">Required</div>) : null}
                      </div>
                      )}
                    </td>
                    <td className="px-6 py-3 ">
                      {item.subTier?.label?.toLowerCase() === "forwarder" && (<div className="min-w-[318px]">
                        <CustomSelect
                          control={control}
                          name={`departurePort${index}`}
                          placeholder="Select port"
                          options={portList}
                          isClearable={false}
                          value={item.departurePort}
                          isError={item?.error?.departurePortError}
                          handleOnChange={(value) => {
                            onChangeHandler(index, "departurePort", value)
                            // if (selectedOrderDocumentsId) {
                            //   setIsManuallyValuesSet(true);
                            //   setIsInitialValuesSet(false);
                            // }
                          }}
                          // {...register("ship_from")}
                          style={{
                            padding: "4px 10px 4.5px 6px",
                            fontSize: "16px",
                            width: "100%",
                            iconSize: 16,
                          }}
                          isDisabled={item.subTier?.label?.toLowerCase() !== "forwarder"}
                        />
                      </div>)}
                    </td>
                    <td className="px-6 py-3 ">
                      {item.subTier?.label?.toLowerCase() === "forwarder" && (<div className="min-w-[318px]">
                        <CustomSelect
                          control={control}
                          name={`arrivalPort${index}`}
                          placeholder="Select port"
                          options={portList}
                          isClearable={false}
                          value={item.arrivalPort}
                          isError={item?.error?.arrivalPortError}
                          handleOnChange={(value) => {
                            onChangeHandler(index, "arrivalPort", value)
                            // if (selectedOrderDocumentsId) {
                            //   setIsManuallyValuesSet(true);
                            //   setIsInitialValuesSet(false);
                            // }
                          }}
                          // {...register("ship_from")}
                          style={{
                            padding: "4px 10px 4.5px 6px",
                            fontSize: "16px",
                            width: "100%",
                            iconSize: 16,
                            }}
                          isDisabled={item.subTier?.label?.toLowerCase() !== "forwarder"}
                        />
                      </div>)}
                    </td>
                    <td className="px-6 py-3">
                      {item.subTier?.label?.toLowerCase() === "forwarder" && (<div className="relative min-w-[144px] w-full">
                        <Datepicker
                          name={`etd${index}`}
                          useRange={false}
                          asSingle={true}
                          value={item.etd}
                          placeholder={"Select date"}
                          displayFormat="DD/MM/YYYY"
                          containerClassName="certificate-date-picker "
                          inputClassName={`flex justify-between w-full gap-3 px-4 h-[44px] relative py-2 items-center text-global-title text-base placeholder:text-input-text-placeholder placeholder:text-base placeholder:font-normal self-stretch border focus:shadow-[none] focus:ring-offset-input-surface-background focus:border-input-stroke-active focus:ring-input-stroke-active bg-dropdown-surface-background rounded-lg z-[2] border-dropdown-stroke-default`}
                          primaryColor={"emerald"}
                          toggleClassName="absolute text-icon-fill-input custom-toggle-icon right-0 h-full z-[4]"
                          onChange={(value) => {
                            onChangeHandler(index, "etd", setTimeInDateObject(value));
                          }}
                          popperPlacement="auto"
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                            },
                          }}
                          disabled={item.subTier?.label?.toLowerCase() !== "forwarder"}
                        />
                        {item.error.etdError && (<div className="text-gray-600 text-xs mt-1">Required</div>)}
                      </div>)}
                    </td>
                    <td className="px-6 py-3">
                      {item.subTier?.label?.toLowerCase() === "forwarder" && (<div className="relative min-w-[144px] w-full">
                        <Datepicker
                          name={`eta${index}`}
                          useRange={false}
                          asSingle={true}
                          value={item.eta}
                          placeholder={"Select date"}
                          displayFormat="DD/MM/YYYY"
                          containerClassName="certificate-date-picker "
                          inputClassName={`flex justify-between w-full gap-3 px-4 h-[44px] relative py-2 items-center text-global-title text-base placeholder:text-input-text-placeholder placeholder:text-base placeholder:font-normal self-stretch border focus:shadow-[none] focus:ring-offset-input-surface-background focus:border-input-stroke-active focus:ring-input-stroke-active bg-dropdown-surface-background rounded-lg z-[2] border-dropdown-stroke-default`}
                          primaryColor={"emerald"}
                          toggleClassName="absolute text-icon-fill-input custom-toggle-icon right-0 h-full z-[4]"
                          onChange={(value) => {
                            onChangeHandler(index, "eta", setTimeInDateObject(value));
                          }}
                          popperPlacement="auto"
                          popperModifiers={{
                            preventOverflow: {
                              enabled: true,
                            },
                          }}
                          disabled={item.subTier?.label?.toLowerCase() !== "forwarder"}
                        />
                      {(item.error.etaError && item.etd?.startDate && item.eta?.startDate && item.eta.startDate < item.etd.startDate) ? (<div className="text-gray-600 text-xs mt-1">ETA date must not be earlier than ETD date</div>) : item.error.etaError? (<div className="text-gray-600 text-xs mt-1">Required</div>) : null}
                      </div>)}
                    </td>
                    <td className="px-4 pb-2">
                      {Object.values(item.error).some((value) => value === true) ? (
                        <>
                          <XCircle
                            fillColor={"var(--color-icon-fill-danger)"}
                            width={24}
                            height={24}
                          />
                        </>
                      ) : (
                        <TicCircle
                          fillColor={"var(--color-icon-fill-active)"}
                          width={26}
                          height={26}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8">
          <Divider />
        </div>
        <div className="flex justify-between gap-4 pt-6 px-6">
          <div className="w-full flex justify-end items-center gap-3 ">
            <Button
              type="button"
              size={"md"}
              variant={"secondary"}
              className={`w-auto h-11 px-4 py-2.5 text-base leading-6 font-semibold `}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            {!preview && (
              <Button
                type="button"
                size={"md"}
                className={`w-auto h-11 px-4 py-2.5 text-base leading-6 font-semibold `}
                isDisabled={!uploadedData}
                onClick={() => setPreview(true)}
              >
                Update
              </Button>
            )}
            {preview && (
              <Button
                type="button"
                size={"md"}
                variant={"primary"}
                className={`w-auto h-11 px-4 py-2.5 text-base leading-6 font-semibold `}
                isDisabled={hasAnyError()}
                onClick={onSubmitBulkUpload}
              >
                Update
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default UpdateOrderPreview;
